import Cookies from 'js-cookie';
import { LinecheckBasicPropConfig } from '../../services';
import { API_BASE_BASEPOINT } from '../LineCheckV3/api-constants';
import { apiResConstants } from '../LineCheckV3/APIResourceConstants';
import { v4 as generateUID } from 'uuid';
import { errorTrackingDataLayer } from '../../utils/AnalyticsUtils';
import { ApiServiceV2 } from '@sunrise-upc/ajax-lib';

export const fetchAddress = async (
  address: any,
  controllerRef: any,
  setAddErr: any,
  count: number = 10
) => {
  if (controllerRef.current) {
    controllerRef.current.abort();
  }
  controllerRef.current = new AbortController();
  const signal = controllerRef.current.signal;
  const endPoint = LinecheckBasicPropConfig?.getInstance()?.getBaseUrl();

  try {
    const response = await fetch(
      `${endPoint}${API_BASE_BASEPOINT.ADDR_SUGG}${
        apiResConstants.ADDR_ENDPOINT
      }?count=${count}&address=${address.replace(/,(?=[^\s])/g, ', ')}`,
      {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
          'x-correlation-id': generateUID(),
          'x-sunrise-channel': apiResConstants.X_SUN_CHAL
        },
        signal: signal
      }
    );
    if (!response.ok) {
      if (response.status === 404 || response.status === 504 || response.status === 500) {
        setAddErr(true);
      }
    }
    const data = await response.json();
    if (data) {
      const addressRes: any[] = [];
      data?.items &&
        data?.items.forEach((item: any) => {
          if (item?.street && item?.houseNumber && item?.postCode && item?.city) {
            item.concatedAddress = `${item?.street} ${item?.houseNumber},${item?.postCode} ${item?.city}`;
            addressRes.push(item);
          }
        });
      return addressRes;
    }
  } catch (error) {
    if (error instanceof DOMException && error.name === 'AbortError') {
      return { abortError: true };
    }
    // eslint-disable-next-line no-console
    console.log(error);
    return { error: true };
  }
};

export const getLineCheckService = (selectedAdd: any, setLcData: any, lcData: any) => {
  const endPoint = LinecheckBasicPropConfig?.getInstance()?.getBaseUrl();
  const options = {
    params: {},
    headers: {
      'x-sunrise-channel': apiResConstants.X_SUN_CHAL,
      'x-correlation-id': generateUID()
    }
  };
  const requestBody: any = {
    address: selectedAdd,
    segment: 'Residential'
  };
  try {
    const URL = `${endPoint}${API_BASE_BASEPOINT.CATELOG_MGMT}${apiResConstants.LINE_CHECK}`;
    return ApiServiceV2.getApiServiceInstance()
      .post(URL, requestBody, options)
      .then((res: any) => {
        if (res.status == 200) {
          const corelationaId = res?.config?.headers?.['x-correlation-id'];
          try {
            typeof window !== 'undefined' &&
              localStorage.removeItem('one-commerce-linecheckcorrelationid');
            typeof window !== 'undefined' &&
              localStorage.setItem('one-commerce-linecheckcorrelationid', corelationaId);
          } catch {
            //
          }
          typeof window !== 'undefined' &&
            Cookies.remove('one-commerce-linecheckcorrelationid', { path: '/' });
          typeof window !== 'undefined' &&
            Cookies.set('one-commerce-linecheckcorrelationid', corelationaId, {
              path: '/',
              expires: 3
            });
          return {
            response: res?.data,
            corelationaId
          };
        } else if (
          res.status === 504 ||
          res.status === 500 ||
          res.status === 404 ||
          res.status === 400
        ) {
          setLcData({ ...lcData, apiErr: true });
        }
        return [];
      })
      .catch((error) => {
        setLcData({ ...lcData, apiErr: true });

        if (error?.response?.data?.code || error?.response?.status === 504) {
          errorTrackingDataLayer(error?.response);
        }
        return error;
      });
  } catch (error) {
    return error;
  }
};

export const fetchLineCheck = async (payload: any, setLcData: any, lcData: any) => {
  const response: any = await getLineCheckService(payload, setLcData, lcData);

  if (response?.response && response?.response?.status === 400) {
    setLcData({ ...lcData, apiErr: true });
    throw Error('linecheck failed');
  }

  const eligibleBundle = await (response?.response?.sellableProducts || []).map(
    (singleProduct: any) => singleProduct.name
  );
  const configEligibleBundle: string[] = [];

  // old code
  // if condition is added as part of defect 326028 to ignore the eligibleCombinations
  if (
    response?.response?.eligibleCombinations &&
    Array.isArray(response?.response?.eligibleCombinations) &&
    response?.response?.eligibleCombinations.length > 0
  ) {
    for (const element of response?.response?.eligibleCombinations) {
      for (const rate of element?.rateplans) {
        configEligibleBundle.push(rate?.name);
      }
    }
  }
  const maxUploadDownloadSpeed = response?.response?.eligibleSpeed?.maxSpeed;
  const plannedUpgrade = response?.response?.eligibleSpeed?.plannedUpgrades;
  const accessType = response?.response?.eligibleAccess;

  try {
    typeof window !== 'undefined' &&
      localStorage.setItem(
        'lineCheckResponse',
        JSON.stringify({
          eligibleBundle: eligibleBundle,
          configEligibleBundle: configEligibleBundle,
          maxUploadDownloadSpeed: maxUploadDownloadSpeed,
          plannedUpgrade: plannedUpgrade,
          originalLinecheckResponse: response?.response,
          accessType: accessType
        })
      );
    try {
      typeof window !== 'undefined' &&
        localStorage.setItem('one-commerce-access-type', JSON.stringify(accessType));
    } catch {
      //
    }
    //Setting expiry, for cli call accesstype required in deeplink flow
    typeof window !== 'undefined' &&
      Cookies.set('one-commerce-access-type', JSON.stringify(accessType), {
        path: '/',
        expires: 3
      });
  } catch {
    //
  }
  return {
    corelationaId: response.corelationaId,
    lineCheckResponse: response?.response,
    eligibleBundle,
    maxUploadDownloadSpeed,
    configEligibleBundle,
    plannedUpgrade
  };
};
